import { useState, useRef } from "react";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Typography,
    Button,
    Box,
    Grid,
    CardMedia,
    Tooltip,
    DialogActions,
} from "@mui/material";
import BusinessFormModal from "./BusinessFormModal";
import { axiosInstance } from "./tokenSetCookie";
import { useTranslation } from "react-i18next";
import { useCart } from "../hooks/shareContext";
import Player from "../users/dashboard/home/Player";
const VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const LIGER_DOMAIN = import.meta.env.VITE_LIGER_HOST_NAME;
const hostName = window.location.host
const isLigerDomain = hostName.includes(LIGER_DOMAIN);
type animationVideo = {
    animationId: number;
    animationTagName: string;
    bannerUrl: string;
    homepageOrder: number;
    videoUrl: string;
};
export default function SequentialVideoModals() {


    const [open, setOpen] = useState(true);
    const [step, setStep] = useState("intro"); // intro | promo
    // const [openIntro, setOpenIntro] = useState(true);
    // const [openPromo, setOpenPromo] = useState(false);
    const [isAnimationVideo, setIsAnimationVideo] = useState<animationVideo | null>(null);
    const [openBusinessModal, setOpenBusinessModal] = useState(false);
    const videoRef = useRef(null);
    const { t } = useTranslation();
    const {
        setSelectAnim,
        cartCount,
        incrementCartCount,

    } = useCart();
    const handleIntroEnd = () => {
        // setOpenIntro(false);
        setStep("promo")
        // setTimeout(() => setOpenPromo(true), 300);
        firstUserStatus();
    };

    const firstUserStatus = async () => {
        try {
            const response = await axiosInstance.get(`${API_BASE_URL}users/update-login`)
            if (response.status >= 200) {
                console.log("status changed successfully!");
                firstUserShare();
            }
        } catch (error) {
            console.error("something went wrong", error)
        }
    }

    const firstUserShare = async () => {
        try {
            const response = await axiosInstance.get(`${API_BASE_URL}systems/get-first-animation-share`)

            if (response.status >= 200) {
                localStorage.setItem("firstTimeUser", JSON.parse("null"));
                // console.log("response", response.data.data[0]);

                setIsAnimationVideo(response.data.data[0]);

                // localStorage.setItem("firstTimeUser", JSON.parse("null"))
                // console.log("status changed successfully!")
            }
        } catch (error) {
            console.error("something went wrong", error)
        }
    }


    const handleSubmit = () => {
        setStep("")
        setOpen(false)
        setOpenBusinessModal(true)
        setSelectAnim((prevIds: number[]) => [...prevIds, isAnimationVideo?.animationId || 0]);
        incrementCartCount(cartCount + 1);
        // setOpenPromo(false);
    };



    return (
        <>

            <Dialog
                open={open}
                fullWidth
                maxWidth={"lg"}
                disableEscapeKeyDown
                PaperProps={{
                    sx: {
                        height: step === "intro" ? "auto" : "750px",
                        display: "flex",
                        flexDirection: "column",
                        borderRadius: "20px",
                        p: 2
                    },
                }}
                onClose={() => { }} // disable outside click
            >
                {step === "intro" && (
                    <>
                        <DialogTitle textAlign="center">
                            Welcome to {isLigerDomain ? "Liger Visuals" : "Clinical Visuals"}
                        </DialogTitle>
                        <DialogContent>
                            <Box
                                sx={{
                                    width: "100%",
                                    height: "auto",
                                    position: "relative",
                                    "& .vds-media-player": { width: "100%", height: "100%" },
                                    "& .vds-video": {
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "contain",
                                    },
                                }}
                            >
                                <Player
                                    ref={videoRef}
                                    className="carouselvideo"
                                    src={`${VISUALIZE__URL}liger_user_guide.mp4`}
                                    autoPlay
                                    muted
                                    poster={`${VISUALIZE__URL}Clinical_Visuals_ENT_Demo_poster.webp`}
                                    showControls={true}
                                    onEnded={handleIntroEnd}
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                    }}
                                />
                            </Box>
                            <Typography
                                variant="body2"
                                textAlign="center"
                                sx={{ color: "text.secondary" }}
                            >
                                Note: This video will give you a brief overview of Clinical
                                Visuals features and usability.
                            </Typography>
                        </DialogContent>
                    </>
                )}

                {step === "promo" && (
                    <>
                        <DialogTitle
                            textAlign="center"
                            sx={{ borderBottom: "1px solid #e5e5e5" }}
                        >
                            Try Share Animation
                        </DialogTitle>
                        <DialogContent>
                            <Box>
                            </Box>
                            <Grid item sm={6} xs={6} md={3} sx={{ height: "95%" }}>
                                <Typography variant="h6" py={3} textAlign={"center"}>This is how you can share animation with your clients/patients.</Typography>
                                <Box
                                    sx={{
                                        position: "relative",
                                        maxWidth: "250px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <CardMedia
                                        component="img"
                                        loading="lazy"
                                        image={isAnimationVideo?.bannerUrl}
                                        sx={{
                                            width: "100%",
                                            aspectRatio: "1.3 / 1",
                                            objectFit: "cover",
                                            borderRadius: "15px",
                                            transition: "all 0.3s ease-in-out",
                                        }}
                                    />
                                    {/* <Box
                                        sx={{
                                            position: "absolute",
                                            bottom: 0,
                                            left: 0,
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            backgroundColor: "#00000061",
                                            width: "100%",
                                            padding: "10px 15px",
                                            gap: "8px",
                                            borderBottomLeftRadius: "15px",
                                            borderBottomRightRadius: "15px",
                                        }}
                                    >
                                        <Tooltip title="Common Cold" placement="top">
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    fontSize: "14px",
                                                    color: "#fff",
                                                    textShadow: "0 1px 2px rgba(0,0,0,0.6)",
                                                    display: "-webkit-box",
                                                    WebkitLineClamp: 2,
                                                    WebkitBoxOrient: "vertical",
                                                    overflow: "hidden",
                                                }}
                                            >
                                                Common Cold
                                            </Typography>
                                        </Tooltip>
                                    </Box> */}
                                </Box>
                                <Tooltip title="" placement="top">
                                    <Typography
                                        variant="caption"
                                        sx={{
                                            fontSize: "16px",
                                            color: "black",
                                            fontWeight: "bold",
                                            // textShadow: "0 1px 2px rgba(0,0,0,0.6)",
                                            display: "-webkit-box",
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: "vertical",
                                            overflow: "hidden",
                                            ml: 1,
                                            mt: 1
                                        }}
                                    >
                                        {t(isAnimationVideo?.animationTagName || "")}
                                    </Typography>
                                </Tooltip>


                            </Grid>
                            <Typography>
                                Let's try to share this animations.
                            </Typography>
                        </DialogContent>
                        <DialogActions
                            sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                padding: "16px 24px",
                                borderTop: "1px solid #ddd",
                            }}
                        >
                            <Button variant="contained" color="primary" onClick={handleSubmit}>
                                Proceed
                            </Button>
                        </DialogActions>

                    </>
                )}
            </Dialog>

            {openBusinessModal && <BusinessFormModal onCloseModal={() => setOpenBusinessModal(false)} />}


        </>

    );
}
